export enum CandidateSource {
    LinkedIn = 'Linkedin',
    Referred = 'Referred',
    RebApplicant = 'Web applicant',
}